(function () {
  var root = document.querySelector('[data-mfp]');
  if (!root) return;
  var variants = JSON.parse(root.querySelector('[data-mfp-variants]').textContent);
  var onRequest = root.getAttribute('data-on-request') === 'true';
  var fallbackRef = root.getAttribute('data-style-code') || '';
  var metalOptIndex = -1;
  var opts = Array.prototype.slice.call(root.querySelectorAll('[data-mfp-option]'));
  var selected = opts.map(function (o) {
    var p = o.querySelector('[aria-pressed="true"]');
    return p ? p.getAttribute('data-mfp-value') : null;
  });
  opts.forEach(function (o, i) { if (o.querySelector('.mfp-swatches')) metalOptIndex = i; });

  function money(cents) {
    var v = cents / 100;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function niceMetal(v) {
    if (!v) return '';
    var s = v.toLowerCase();
    if (s.indexOf('platinum') > -1) return 'Platinum';
    var k = (s.match(/(\d{2})\s*k/) || [])[1];
    var c = s.indexOf('yellow') > -1 ? 'Yellow' : s.indexOf('rose') > -1 || s.indexOf('pink') > -1 ? 'Rose' : s.indexOf('white') > -1 ? 'White' : s.indexOf('two') > -1 ? 'Two-Tone' : '';
    if (!c) return v;
    return (k ? k + 'k ' : '') + c + ' Gold';
  }
  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return selected[i] == null || val === selected[i]; });
    });
  }
  function update(initial) {
    var v = findVariant();
    var priceEl = root.querySelector('[data-mfp-price]');
    var skuEl = root.querySelector('[data-mfp-sku]');
    var idEl = root.querySelector('[data-mfp-variant]');
    var addEl = root.querySelector('[data-mfp-add]');
    var metalEl = root.querySelector('[data-mfp-metal]');
    if (v) {
      if (!onRequest && priceEl) priceEl.textContent = v.price > 0 ? money(v.price) : 'Price upon request';
      if (skuEl) skuEl.textContent = v.sku || fallbackRef || '';
      if (idEl) idEl.value = v.id;
      if (addEl) { addEl.disabled = !v.available; addEl.textContent = v.available ? 'Add to bag' : 'Unavailable'; }
      if (metalEl && metalOptIndex > -1 && selected[metalOptIndex]) metalEl.textContent = niceMetal(selected[metalOptIndex]);
      var shownEl = root.querySelector('[data-mfp-shown]');
      var anyOwn = variants.some(function (x) { return x.featured_image && x.featured_image.src; });
      var thumbsAll = root.querySelectorAll('[data-mfp-thumb]');
      var th = null;
      if (v.featured_image && v.featured_image.src) {
        var fileOf = function (u) { return (u || '').split('?')[0].split('/').pop(); };
        var want = fileOf(v.featured_image.src);
        th = Array.prototype.find.call(thumbsAll, function (t) { return fileOf(t.getAttribute('data-src')) === want; });
        if (shownEl && metalOptIndex > -1 && selected[metalOptIndex]) shownEl.textContent = 'Shown in ' + niceMetal(selected[metalOptIndex]).replace(/ (Yellow|White|Rose|Two-Tone) Gold$/, function (m) { return m.toLowerCase(); }).replace(/^Platinum$/, 'platinum');
      } else {
        if (anyOwn && thumbsAll.length) th = thumbsAll[0];
        if (shownEl) shownEl.textContent = 'Shown in ' + shownEl.getAttribute('data-default');
      }
      if (th && th.getAttribute('aria-current') !== 'true') setTimeout(function () { th.click(); }, 0);
      root.querySelectorAll('a[href*="reference="]').forEach(function (a) {
        a.href = a.href.replace(/reference=[^&]*/, 'reference=' + encodeURIComponent(v.sku || fallbackRef || ''));
      });
      if (!initial) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
    } else if (addEl) { addEl.disabled = true; addEl.textContent = 'Unavailable'; }
  }
  opts.forEach(function (o, i) {
    o.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mfp-value]');
      if (!b) return;
      selected[i] = b.getAttribute('data-mfp-value');
      o.querySelectorAll('[data-mfp-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var lbl = o.querySelector('[data-mfp-opt-value]'); if (lbl) lbl.textContent = i === metalOptIndex ? niceMetal(selected[i]) : selected[i];
      update();
    });
  });
  if (metalOptIndex > -1) {
    var l0 = opts[metalOptIndex].querySelector('[data-mfp-opt-value]');
    if (l0) l0.textContent = niceMetal(selected[metalOptIndex]);
    update(true);
  }
  var main = root.querySelector('.mfp-main-img');
  root.querySelectorAll('[data-mfp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.getAttribute('data-src'); main.removeAttribute('srcset'); main.alt = t.getAttribute('data-alt');
      root.querySelectorAll('[data-mfp-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    });
  });
  var desc = root.querySelector('[data-mfp-desc]');
  var more = root.querySelector('[data-mfp-more]');
  if (desc && more) {
    var rte = desc.querySelector('.rte');
    if (rte.scrollHeight <= rte.clientHeight + 4) { more.hidden = true; desc.setAttribute('data-clamped', 'false'); }
    more.addEventListener('click', function () {
      var c = desc.getAttribute('data-clamped') === 'true';
      desc.setAttribute('data-clamped', c ? 'false' : 'true');
      more.textContent = c ? 'Read less' : 'Read more';
    });
  }
})();

/* MF zoom: full-screen viewer, loads the full-detail photo only when opened */
(function () {
  var root = document.querySelector('[data-mfp]');
  if (!root) return;
  var mainBox = root.querySelector('.mfp-main');
  var main = root.querySelector('.mfp-main-img');
  if (!mainBox || !main) return;
  function big(u) { return u ? u.replace(/([?&])width=\d+/, '$1width=5000') : u; }
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mfp-thumb]'));
  var list = thumbs.length ? thumbs.map(function (t) { return { s: t.getAttribute('data-src'), a: t.getAttribute('data-alt') || '' }; })
                           : [{ s: main.currentSrc || main.src, a: main.alt || '' }];
  var cur = Math.max(0, thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; }));
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { cur = i; }); });

  var css = document.createElement('style');
  css.textContent =
    '.mfp-main{cursor:zoom-in;position:relative}' +
    '.mfz-hint{position:absolute;right:12px;bottom:12px;width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.9);border:1px solid #ddd;display:flex;align-items:center;justify-content:center;pointer-events:none}' +
    '.mfz{position:fixed;inset:0;z-index:2147483000;background:#fff;display:none}' +
    '.mfz[open-z]{display:block}' +
    '.mfz-stage{position:absolute;inset:0;overflow:hidden;display:flex;align-items:center;justify-content:center;cursor:zoom-in;touch-action:pinch-zoom}' +
    '.mfz-stage img{max-width:100%;max-height:100%;object-fit:contain;user-select:none;-webkit-user-drag:none}' +
    '.mfz[data-z="1"] .mfz-stage{overflow:auto;display:block;cursor:zoom-out;touch-action:auto}' +
    '.mfz[data-z="1"] .mfz-stage img{max-width:none;max-height:none;display:block}' +
    '.mfz button{position:absolute;z-index:2;background:rgba(255,255,255,.92);border:1px solid #ddd;border-radius:50%;width:44px;height:44px;font-size:22px;line-height:1;color:#111;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}' +
    '.mfz-close{top:16px;right:16px}.mfz-prev{left:16px;top:50%;transform:translateY(-50%)}.mfz-next{right:16px;top:50%;transform:translateY(-50%)}' +
    '.mfz-count{position:absolute;bottom:18px;left:50%;transform:translateX(-50%);z-index:2;font-size:13px;letter-spacing:.08em;color:#555;background:rgba(255,255,255,.9);padding:4px 10px;border-radius:12px}' +
    '.mfz-load{position:absolute;top:22px;left:50%;transform:translateX(-50%);z-index:2;font-size:12px;color:#888;display:none}' +
    '.mfz[data-loading="1"] .mfz-load{display:block}' +
    '.mfz[data-nozoom="1"] .mfz-stage{cursor:default}';
  document.head.appendChild(css);

  var hint = document.createElement('span');
  hint.className = 'mfz-hint'; hint.setAttribute('aria-hidden', 'true');
  hint.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-5-5M11 8v6M8 11h6"/></svg>';
  mainBox.appendChild(hint);

  var ov = document.createElement('div');
  ov.className = 'mfz'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Zoomed product photo');
  ov.innerHTML = '<div class="mfz-stage"><img alt=""></div>' +
    '<button type="button" class="mfz-close" aria-label="Close">&times;</button>' +
    (list.length > 1 ? '<button type="button" class="mfz-prev" aria-label="Previous photo">&#8249;</button><button type="button" class="mfz-next" aria-label="Next photo">&#8250;</button><div class="mfz-count"></div>' : '') +
    '<div class="mfz-load">Loading full detail…</div>';
  document.body.appendChild(ov);
  var stage = ov.querySelector('.mfz-stage'), img = stage.querySelector('img'), count = ov.querySelector('.mfz-count');
  var token = 0, lastFocus = null;

  var fullW = 0, fullH = 0, want = null;
  function zoomW() { return fullW / Math.min(window.devicePixelRatio || 1, 2); }
  function canZoom() { return fullW > 0 && zoomW() > img.getBoundingClientRect().width * 1.25; }
  function setZoom(on, cx, cy) {
    if (!on) { ov.setAttribute('data-z', '0'); img.style.width = ''; want = null; return; }
    if (!fullW) { want = [cx, cy]; return; }
    if (!canZoom()) return;
    var r = img.getBoundingClientRect();
    var fx = r.width ? (cx - r.left) / r.width : .5, fy = r.height ? (cy - r.top) / r.height : .5;
    var vw = stage.clientWidth, vh = stage.clientHeight;
    var w = zoomW(), h = w * fullH / fullW;
    ov.setAttribute('data-z', '1');
    img.style.width = w + 'px';
    stage.scrollLeft = Math.max(0, fx * w - vw / 2);
    stage.scrollTop = Math.max(0, fy * h - vh / 2);
  }
  function show(i) {
    cur = (i + list.length) % list.length;
    var it = list[cur], my = ++token;
    setZoom(false);
    fullW = 0; fullH = 0;
    img.src = it.s; img.alt = it.a;
    if (count) count.textContent = (cur + 1) + ' / ' + list.length;
    ov.setAttribute('data-nozoom', '0');
    ov.setAttribute('data-loading', '1');
    var hi = new Image();
    hi.onload = function () {
      if (my !== token) return;
      img.src = hi.src; fullW = hi.naturalWidth; fullH = hi.naturalHeight;
      ov.setAttribute('data-loading', '0');
      ov.setAttribute('data-nozoom', canZoom() ? '0' : '1');
      if (want) { var c = want; want = null; setZoom(true, c[0], c[1]); }
    };
    hi.onerror = function () { if (my === token) ov.setAttribute('data-loading', '0'); };
    hi.src = big(it.s);
  }
  function open() {
    lastFocus = document.activeElement;
    ov.setAttribute('open-z', ''); document.documentElement.style.overflow = 'hidden';
    show(cur); ov.querySelector('.mfz-close').focus();
  }
  function close() {
    ov.removeAttribute('open-z'); document.documentElement.style.overflow = ''; token++; setZoom(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  mainBox.addEventListener('click', function (e) { if (e.target.closest('a,button')) return; open(); });

  var downX = 0, downY = 0, moved = false;
  stage.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; });
  stage.addEventListener('pointermove', function (e) {
    if (Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY) > 8) moved = true;
    if (e.pointerType === 'mouse' && ov.getAttribute('data-z') === '1') {
      var fx = e.clientX / stage.clientWidth, fy = e.clientY / stage.clientHeight;
      stage.scrollLeft = fx * (stage.scrollWidth - stage.clientWidth);
      stage.scrollTop = fy * (stage.scrollHeight - stage.clientHeight);
    }
  });
  stage.addEventListener('click', function (e) {
    if (moved) return;
    if (ov.getAttribute('data-z') === '1') setZoom(false); else setZoom(true, e.clientX, e.clientY);
  });
  ov.querySelector('.mfz-close').addEventListener('click', close);
  var pv = ov.querySelector('.mfz-prev'), nx = ov.querySelector('.mfz-next');
  if (pv) pv.addEventListener('click', function () { show(cur - 1); });
  if (nx) nx.addEventListener('click', function () { show(cur + 1); });
  document.addEventListener('keydown', function (e) {
    if (!ov.hasAttribute('open-z')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft' && list.length > 1) show(cur - 1);
    else if (e.key === 'ArrowRight' && list.length > 1) show(cur + 1);
  });
  var sx = null;
  stage.addEventListener('touchstart', function (e) { sx = (e.touches.length === 1 && ov.getAttribute('data-z') !== '1') ? e.touches[0].clientX : null; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (sx == null || list.length < 2) return;
    var dx = e.changedTouches[0].clientX - sx; sx = null;
    if (Math.abs(dx) > 50) { moved = true; show(cur + (dx < 0 ? 1 : -1)); }
  });
})();
